import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "servererror",
    templateUrl: "./servererror.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class ServerErrorComponent {

}
